import { render, staticRenderFns } from "./error_products_list.vue?vue&type=template&id=a924f926&scoped=true&"
import script from "./error_products_list.vue?vue&type=script&lang=js&"
export * from "./error_products_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a924f926",
  null
  
)

export default component.exports